import { isUseAPI } from '@/utils/check'
import request from '@/utils/request'

export function getHrManage(searchParams, isNotify) {
  return request({
    url: `/api/getHrManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: searchParams,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

export function getHrApi(param) {
  let isTest = false

  if (!isUseAPI() || isTest) {
    return new Promise(function(resolve, reject) {
      let res = getHrApiData
      //console.log('api', res)
      resolve(res.msg)
    })
  }
  return request({
    url: `/api/getHrApi`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: param
  })
}
export function getHrJbrpApi(param) {
  let isTest = false

  if (!isUseAPI() || isTest) {
    return new Promise(function(resolve, reject) {
      let res = getHrApiData
      //console.log('api', res)
      resolve(res.msg)
    })
  }
  return request({
    url: `/api/getHrJbrpApi`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: param
  })
}
export function getHrInfos(params) {
  return request({
    url: `/api/getHrInfos`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: false, apitype: 'searched' },
  })
} 
export function createNewUserCd(params, isNotify) {
  console.log(params)
  return request({
    url: `/api/createNewUserCd`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}
export function saveHrManage(params, isNotify) {
  console.log(params)
  return request({
    url: `/api/saveHrManage`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

export function deleteHrManage(params, isNotify) {
  //console.log(params)
  return request({
    url: '/api/deleteHrManage',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}
// 사업장 그룹 조회
export function getCompanyGroup(param) {
  return request({
    url: '/api/getCompanyGroup',
    method: 'GET',
    params: param,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    meta: { apiVersion: '1.0.0' },
  })
}

// 사용자 소속 사업장 그룹 조회
export function getUserCompanyGroup(param) {
  return request({
    url: '/api/getUserCompanyGroup',
    method: 'GET',
    params: param,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    meta: { apiVersion: '1.0.0' },
  })
}

// 특정 유저 권한 수준 조회
export function getUserGroupPermission(params) {
  return request({
    url: `/api/getUserGroupPermission`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: false, apitype: 'searched' },
  })
}